import { useFeatureGate } from '@statsig/expo-bindings';

import { FeatureFlags } from '../../../feature-flags/FeatureFlags';
import useGetIncomeSplitFromGlobalState from './useGetIncomeSplitFromGlobalState';

const useShouldSeeIncomeSplit = () => {
    const { value: enableIncomeSplit } = useFeatureGate(
        FeatureFlags.ENABLE_INCOME_SPLIT,
    );

    const { incomeSplit } = useGetIncomeSplitFromGlobalState();

    return (
        enableIncomeSplit ||
        !!(incomeSplit && !incomeSplit.isLegacy && !incomeSplit.isNew)
    );
};

export default useShouldSeeIncomeSplit;
